import { render, staticRenderFns } from "./DropdownSelect3.vue?vue&type=template&id=1d45da50&scoped=true&"
import script from "./DropdownSelect3.vue?vue&type=script&lang=js&"
export * from "./DropdownSelect3.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSelect3.vue?vue&type=style&index=0&id=1d45da50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d45da50",
  null
  
)

export default component.exports